import { PaymentElement } from "@stripe/react-stripe-js"
import React from "react"

import SquarePaymentForm from "./SquarePaymentsForm"

export default function PaymentProviderCardForm({ practice, options, disableLink = false }) {
  // When disableLink=true (practitioner portal):
  // - Prevents Link autofill with browser-cached cards
  // - Client's saved payment methods still show (via customer-scoped setupIntent)
  const stripeOptions = disableLink
    ? {
        ...options,
        wallets: {
          applePay: "never",
          googlePay: "never",
          link: "never" // Disable Link wallet autofill
        }
      }
    : options
  switch (practice.paymentProvider) {
    case "stripe":
      return <PaymentElement options={stripeOptions} />
    case "square":
      return <SquarePaymentForm />
  }
}
